<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <v-breadcrumbs>
            <v-breadcrumbs-item>
              <router-link to="/">Home</router-link>
            </v-breadcrumbs-item>
            <span class="divider">></span>
            <v-breadcrumbs-item disabled>
              Season Parking
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-col>
      </v-row>

      <v-row no-gutters class="px-5">
        <v-col cols="12">
            <h1>Season Parking</h1>
            <h3 class="mb-3">BPS monthly, quaterly and annualy Season Parking Ticket</h3>
            
            <v-row>
                <v-col cols="6">
                    <v-img src="@/assets/season-parking-1.jpeg" class="mb-4" height="400px" width="100%"></v-img>
                </v-col>
                <v-col cols="6">
                    <v-img src="@/assets/season-parking-2.jpeg" class="mb-4" height="400px" width="100%"></v-img>
                </v-col>
            </v-row>

            <div class="mb-12">
                <p class="font-weight-medium">What is a Season Parking Ticket</p>
                <p>
                    Borneo Parking Systems Sdn Bhd (BPS) monthly, quarterly or annually Season Parking Ticket (SPT) allows a motorist to park monthly, quarterly or annually at a any on street numbered car park at any time in Miri City without having to display parking coupons.
                </p>
            </div>

            <div class="mb-12">
                <p class="font-weight-medium">Apply New Season Parking Ticket</p>
                <p>
                    You will have to come to BPS office at One Stop Center, Miri City Council, Jalan Raja, 98000 Miri, Sarawak, Malaysia.<br><br>
                    Fill in the Monthly Season Parking Application form and submit at the counter, BPS counter staffs will key in the necessary data and you will be issued the Season Parking Ticket in less than 3 minutes.<br><br>
                    Monthly Season Parking Tickets at Blue Zone are sold at RM106.00, Quarterly Season Parking at RM318.00 and Yearly at RM1272.00, all inclusive of 6% GST. <br><br>
                    For Renewal of Monthly Season Parking, it is not necessary to fill in the Season Parking Application form again, just write down or tell our counter staffs your vehicle number as our servers already has your records.
                </p>
            </div>

            <div class="mb-12">
                <p class="font-weight-medium">Transfer Season Parking Ticket</p>
                <p>
                    You can transfer your season parking ticket when there is a change of car park and or vehicle.<br><br>
                    There will be a transfer charge fee of RM5.00 with the issuance of a new season parking ticket.
                </p>
            </div>

            <div class="mb-12">
                <p class="font-weight-medium">Lost Season Parking Ticket</p>
                <p>
                    If you lost your season parking ticket, you will be charge RM10.00 when you request for a new one.
                </p>
            </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'SeasonParkingPage'
};
</script>
